module.exports = __webpack_public_path__ + "static/ditsyfloralonesie-8eef40fa216515cf2c22a2e7184ada41.jpeg";